<script setup lang="ts">
import { computed } from 'vue';

import { getCssCustomPropertyValue, getStringStyles } from '@libs/ui';

import { timeRangeMsToHHMM } from './TimeRangeFormatters.helper';
import type { TimeRangeFormatterData } from './TimeRangeFormatter.model';

interface TimeRangeFormatterProps {
  data: TimeRangeFormatterData;
}

const props = defineProps<TimeRangeFormatterProps>();

const style = computed(() =>
  getStringStyles(props.data.color, getCssCustomPropertyValue)
);

const label = computed(() => timeRangeMsToHHMM(props.data.value));
</script>

<template>
  <span :style="style" :class="[props.data.font]">
    {{ label }}
  </span>
</template>
